import styled, {css} from 'styled-components';
import { Asset, CloseIcon } from '../../const/icons';
import { FAMILY_FONT_CONTROL } from '../../const/text'
import {SECONDARY_COLOR, SECONDARY_COLOR_4, SECONDARY_COLOR_5, SECONDARY_COLOR_6} from '../../const/color';
import {device} from "../../const/device";

export const WrapModal = styled.div<{show}>`
  display: ${ props => props.show.display ? 'flex': 'none'};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`

export const Overlay =  styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 0;
`

export const H4 = styled.h4<{themeColor: string}>`
  padding-bottom: 20px;
  color:${props => props.themeColor == "black" ? '#fff' : SECONDARY_COLOR};
`

export const P = styled.p<{themeColor: string}>`
  font-size: 12px;
  text-align: center;
  font-family: ${FAMILY_FONT_CONTROL};
  color:${props => props.themeColor == "black" ? '#fff' : SECONDARY_COLOR};
`
export const Modal = styled.div<{themeColor: string}>`
  display: flex;
  width: 520px;
  height: auto;
  position: relative;
  z-index: 2;
  padding: 20px 30px 30px 30px;
  align-items: center;
  background: ${props => props.themeColor == "black" ? SECONDARY_COLOR :'#f4f4f4'};
  border: ${props => props.themeColor == "black" ? '1px solid #fff': '1px solid #fff'};
  flex-direction: column;
`

export const FirstRow = styled.div`
  display: flex;
  justify-content: space-around;
`

export const IconAsset = styled.span`
  width: 20px;
  height: 20px;
  margin-right: 20px;
  background-image: url("data:image/svg+xml,${Asset()}");
  background-repeat: no-repeat;
`

export const IconAssetMember = styled.span<{enabled, checkAddCart: boolean}>`
  display: ${props => (props.enabled && !props.checkAddCart)?'block' : 'none'};
  position: absolute;
  margin: 10px;
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,${Asset()}");
  background-repeat: no-repeat;
`

export const ButtonIcon = styled.button<{ icon: string, disabled?: boolean, tabletOnly?: boolean, mobileOnly?: boolean }>`
  width: 32px;
  height: 32px;
  position: relative;
  border-radius: 2px;
  outline: 0;
  border: 0;
  left: 225px;
  top: -5px;
  padding: 0;
  background-color: ${SECONDARY_COLOR_6};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};

  @media (${device.tabletS}) {
    left: 170px;
  }
  
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml,${props => props.icon}") no-repeat center;
    pointer-events: none;
  }
  
  &:hover {
    background-color: ${SECONDARY_COLOR_5};  
  }
  &:active {
    background-color: ${SECONDARY_COLOR_4};  
  }
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  ${props => props.tabletOnly ? css`
    display: none;
    @media (${device.tablet}) {
      display: inline-block;
    }
  ` : ''}
  ${props => props.mobileOnly ? css`
    display: none;
    @media (${device.mobileL}) {
      display: inline-block;
    }
  ` : ''}
  
  
  @media (${device.mobileL}) {
    width: 24px;
    height: 24px;
  }
`;

export const ButtonIconClose = styled(ButtonIcon).attrs({ icon: CloseIcon(), areaLabel: 'Close button' })``;